import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import UserAdminService from "../services/UserAdminService";

const useUserAdminService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new UserAdminService(client);
  }, [client]);

  return service;
};

export default useUserAdminService;
